import { isoLanguageCodes } from "../store/Languages";

export function getLanguageFromPath(path: string): isoLanguageCodes {
  const langCodeStart = path.indexOf("/");
  const langCodeEnd = path.indexOf("/", langCodeStart + 1);
  const languageCode = path.substring(
    langCodeStart + 1,
    langCodeEnd
  ) as isoLanguageCodes;
  return languageCode;
}
